import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#fff",
  "fill-rule": "evenodd",
  stroke: "#000",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 60 240"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "none",
      "stroke-width": "2",
      d: "M1.188 1.343h56.625v236.314H1.188z"
    }, null, -1)
  ])))
}
export default { render: render }